import { render, staticRenderFns } from "./DiagramRecordAllPanel.vue?vue&type=template&id=67ae7a31&"
import script from "./DiagramRecordAllPanel.vue?vue&type=script&lang=js&"
export * from "./DiagramRecordAllPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports